import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Auth = lazy(() => import("@/pages/Auth"));

export const Route = createFileRoute("/signup")({
  component: Auth,
});
